import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import React, { useEffect, useState, useRef, useCallback } from 'react';

export default function CardForm({
  inputType,
  listOption,
  titleCard,
  control,
  name,
  setDefaultValue
}) {
  const searchDebounce = useRef();
  const { field } = useController({
    name,
    control
  });

  const [options, setOptions] = useState(null);
  const [checkAll, setCheckAll] = useState(null);

  useEffect(() => {
    if (listOption === null || listOption?.length === 0) {
      setOptions([]);
    } else if (listOption) {
      const newValue = getOptionIsTrue(listOption);
      checkIsSelectedAll(newValue);
      setOptions(listOption);
      setDefaultValue(name, newValue);
    }
  }, [listOption]);

  const checkIsSelectedAll = (value) => {
    listOption?.length === value?.length
      ? setCheckAll(true)
      : setCheckAll(false);
  };

  const handleChangeInputValue = (e) => {
    const value = e.target.value;
    let selected = true;
    if (!e.target.checked) {
      setCheckAll(false);
      selected = false;
    }
    const newValue = setSelectedByValue(value, selected);

    setOptionAndValue(newValue);
  };

  const handleToggleSelectAll = (e) => {
    let selected = true;
    if (!e.target.checked) {
      selected = false;
    }
    const newValue = changeSelectedAllOption(selected) ?? [];
    setCheckAll(selected);
    setOptionAndValue(newValue);
  };

  const changeSelectedAllOption = (selected) => {
    return listOption?.map((item) => ({
      ...item,
      selected: selected
    }));
  };

  const setSelectedByValue = (valueToSelect, selected) => {
    return options?.map((item) => {
      if (item.value === valueToSelect) {
        return { ...item, selected: selected };
      }
      return item;
    });
  };

  const setOptionAndValue = useCallback(
    (data) => {
      setOptions(data);
      const newValue = getOptionIsTrue(data);
      field.onChange(newValue);
      checkIsSelectedAll(newValue);
    },
    [options]
  );

  const getOptionIsTrue = (data) => {
    return data?.filter((item) => {
      return item.selected;
    });
  };

  const handleInputSearch = useCallback(
    async (e) => {
      let newOption;
      const valueInput = e.target.value.toLowerCase();
      if (!valueInput.length) {
        newOption = await Promise.all(
          listOption.map(async (item) => {
            const data = await getDataByValue(item.value, field.value);
            return data ? data : item;
          })
        );
      } else {
        newOption = listOption?.filter((item) => {
          return item.value.toLowerCase().includes(valueInput);
        });
        newOption = await Promise.all(
          newOption.map(async (item) => {
            const data = await getDataByValue(item.value, options);
            if (data) {
              item.selected = data.selected;
            }
            return item;
          })
        );
      }

      setOptions(newOption);
    },
    [options, field.value]
  );
  const getDataByValue = async (valueToFind, data) => {
    const newData = data?.find(
      (item) => item.value.toLowerCase() === valueToFind.toLowerCase() && item
    );
    const result = newData === undefined ? null : newData;
    return result;
  };

  return (
    <div className=" p-4  border rounded-lg shadow-sm">
      <div className="border-b border-black pb-2">
        <p>{titleCard}</p>
      </div>
      <div className="my-4 	">
        {!options ? (
          <div className="animate-pulse space-y-2">
            <div className="h-4 bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            <div className="h-4 bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            <div className="h-4 bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            <div className="h-4 bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            <div className="h-4 bg-gray-300  rounded-md px-3 py-1 my-1"></div>
          </div>
        ) : (
          <>
            <div className="flex flex-1 items-center gap-2 justify-center my-2">
              {checkAll !== null && (
                <div className="w-full max-w-lg">
                  <form className="sm:flex sm:items-center">
                    <input
                      type="checkbox"
                      name="checkBoxAll"
                      checked={checkAll}
                      onChange={handleToggleSelectAll}
                      className="w-[30px] h-[30px] mr-2 border-2 text-gray-200 checkbox rounded-circle"
                    />

                    <div className="relative">
                      <input
                        className="appearance-none border-2  border-gray-400 hover:border-gray-400 transition-colors rounded w-full py-[2px] px-3 text-gray-800 leading-tight focus:outline-none  focus:shadow-outline"
                        id="username"
                        type="text"
                        placeholder="Search"
                        onChange={(e) => {
                          {
                            if (searchDebounce.current) {
                              clearTimeout(searchDebounce.current);
                            }

                            searchDebounce.current = setTimeout(() => {
                              handleInputSearch(e);
                            }, 800);
                          }
                        }}
                      />

                      <div className="absolute right-0 inset-y-0 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 mr-3 text-black text-sm"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>

            <div className="overflow-y-auto max-h-[260px] min-h-[180px] overflow-x-hidden">
              {options.map((item, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <label className="flex bg-gray-100  rounded-md px-3 py-1 my-1  hover:bg-gray-300 cursor-pointer ">
                      <input
                        onChange={handleChangeInputValue}
                        value={item?.value}
                        type={inputType}
                        name={inputType == 'radio' ? name : null}
                        checked={item?.selected}
                      />
                      <p className="pl-2">{item?.value}</p>
                    </label>
                  </React.Fragment>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

CardForm.propTypes = {
  inputType: PropTypes.string,
  listOption: PropTypes.array,
  titleCard: PropTypes.string,
  control: PropTypes.object,
  name: PropTypes.string,
  setDefaultValue: PropTypes.func
};
